import { gql } from '@apollo/client';

export const DELETE_CREW_MEMBER_HOLD_DOWN = gql`
	mutation deleteCrewMemberHoldDown($id: ID!) {
		deleteCrewMemberHoldDown(id: $id) {
			... on CrewMemberHoldDownErrorResponse {
				errors {
					code
				}
			}
		}
	}
`;
